import script from "./SettingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingComponent.vue?vue&type=script&setup=true&lang=js"

import "./SettingComponent.vue?vue&type=style&index=0&id=284886f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284886f4"]])

export default __exports__